import Axios from "axios";

const getAuthedSiteVisitReports = async token =>
  await Axios.get(`${window.API}/site-visit/my-reports`, {
    headers: { Authorization: `Bearer ${token}` },
  });

export { getAuthedSiteVisitReports };
